import { Stack } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";

import { DateFormat, FormInputItem, LooseObject } from "~/utils/Types";
import dayjs from "~/utils/dayjs";

import { earliest, getDateLimits, latest } from "./dateLimits";

export type DatePickerProps = {
  label?: string;
  name?: string;
  item: FormInputItem;
  textFieldProps: LooseObject;
  values: LooseObject;
  setFieldValue: (field: string, value: unknown) => void;
  minDate?: Date;
  maxDate?: Date;
  inputProps?: Record<string, unknown>;
  format?: string;
  showFloatingLabel?: boolean;
};

const DatePicker = ({
  label,
  name,
  item,
  values,
  setFieldValue,
  minDate,
  maxDate,
  textFieldProps,
  format,
}: DatePickerProps) => {
  const fieldName = name || item.name;
  const currentValue = values[fieldName] || item.defaultValue;
  const limits = getDateLimits(item);

  return (
    <Stack w="100%" style={textFieldProps?.sx}>
      <DatePickerInput
        label={label || item.label}
        value={currentValue ? dayjs(currentValue).toDate() : null}
        onChange={(date) => {
          const dayjsDate = date ? dayjs(date) : null;
          setFieldValue(fieldName, dayjsDate);
          item.exposeValue?.(dayjsDate);
        }}
        minDate={latest(
          minDate ? dayjs(minDate).toDate() : undefined,
          limits.minDate,
        )}
        maxDate={earliest(
          maxDate ? dayjs(maxDate).toDate() : undefined,
          limits.maxDate,
        )}
        valueFormat={format || DateFormat.SHORT}
        clearable
        style={{ width: "100%", ...textFieldProps?.style }}
        {...textFieldProps}
      />
    </Stack>
  );
};

export default DatePicker;
